function joinUrl(base: string, path: string) {
  const trimmedBase = base.replace(/\/+$/, "");
  const trimmedPath = path.startsWith("/") ? path : `/${path}`;
  return `${trimmedBase}${trimmedPath}`;
}

/**
 * For production (single deployable server), prefer relative `/api/...` calls.
 * In dev, you can set `VITE_API_BASE_URL=http://localhost:4000` to hit the BFF.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? "";

export function apiUrl(path: string) {
  if (!API_BASE_URL) return path.startsWith("/") ? path : `/${path}`;
  return joinUrl(API_BASE_URL, path);
}



